import React, { useState } from "react";
import { Link } from "react-router-dom";

import { SamphireLogo } from "../assets/logos/samphireLogo";
import { Button } from "../components/coreUI/button";
import { useAuth } from "../components/providers/AuthProvider";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState(false);
  const [loading, setLoading] = useState(false);
  const { forgetPassword } = useAuth();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError("");
    setSuccess(false);
    setLoading(true);

    try {
      await forgetPassword({ email });
      setSuccess(true);
    } catch (err: any) {
      setError(err.message || "An error occurred while sending reset email");
    } finally {
      setLoading(false);
    }
  };

  if (success) {
    return (
      <div className="w-screen h-screen flex flex-col items-center justify-center">
        <h2>Check your email</h2>
        <p className="ph-no-capture">
          We've sent a password reset link to {email}
        </p>
        <div className="auth-links">
          <Link to="/auth?mode=login">Back to sign in</Link>
        </div>
      </div>
    );
  }

  return (
    <div className="w-screen h-screen pt-12 items-center justify-center ">
      <div className="max-w-[350px] mx-auto flex flex-col items-center justify-center my-auto ">
        <div className="w-full h-full flex flex-col items-center justify-center mt-8 mb-8 px-8">
          <SamphireLogo width={200} className="text-foreground-primary" />
          <p className="text-xl font-semibold text-foreground-secondary">
            Member Portal
          </p>
          <p className="text-sm text-center mt-2 text-foreground-secondary max-w-[300px]">
            Enter your email address and if it matches our records we'll send
            you a link to reset your password.
          </p>
        </div>
      </div>
      <div className="flex flex-col gap-4 mx-auto max-w-[300px]">
        <form onSubmit={handleSubmit} className="flex flex-col gap-4">
          <input
            type="email"
            placeholder="Email address"
            value={email}
            className="ph-no-capture border border-gray-300 rounded-full min-w-[300px] px-4 py-2"
            onChange={(e) => setEmail(e.target.value)}
            required
          />

          {error && <div className="auth-error">{error}</div>}

          <Button
            type="submit"
            disabled={loading}
            variant="primary"
            size="default"
            fullWidth
          >
            {loading ? "Sending..." : "Send reset link"}
          </Button>
        </form>

        <Button variant="tertiary" size="default" as="link" to="/auth">
          Back
        </Button>
      </div>
    </div>
  );
}
